<template>
    <div class="visual-tooltip-parking">
        <div v-if="tooltip.number" class="visual-tooltip-parking__title">Место №{{ tooltip.number }}</div>
        <div v-if="tooltip.area" class="visual-tooltip-parking__area">{{ replaceDotComma(tooltip.area) }} м2</div>
        <div v-if="tooltip.area" :class="['visual-tooltip-parking__price', {'is-new':tooltip.priceOld}]">
            {{ formatPrice(tooltip.price) }} руб
        </div>
        <div v-if="tooltip.priceOld" class="visual-tooltip-parking__price-old">
            {{ formatPrice(tooltip.priceOld) }} руб
        </div>
    </div>
</template>

<script>
export default {
    props: {
        tooltip: Object
    },

    methods: {
        formatPrice(value) {
            const val = (value / 1).toFixed(0).replace('.', ',');

            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        },

        replaceDotComma(value) {
            return `${value}`.replace('.', ',');
        }
    }
};
</script>
